import { render } from "./BuyAut.vue?vue&type=template&id=7b8d83f5"
import script from "./BuyAut.vue?vue&type=script&lang=js"
export * from "./BuyAut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__